import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import ValuesSection from './components/ValuesSection';
import { useSEO, generateOrganizationSchema, generateServiceSchema } from '../../utils/seo';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      generateOrganizationSchema(),
      generateServiceSchema(),
      {
        '@type': 'WebSite',
        name: 'Arion Energy',
        url: siteUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${siteUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string'
        }
      }
    ]
  };

  useSEO({
    title: '亞立原 Arion - 數位科技與創新服務領導品牌 | 遊戲產品代理、研發與市場推廣',
    description: '亞立原 Arion 是台灣領先的數位科技與創新服務品牌，專注於遊戲產品代理、研發與市場推廣。我們致力於鏈結創意與玩家體驗，提供全方位的遊戲產業解決方案，包括遊戲代理、產品研發、市場推廣、玩家社群經營等專業服務。',
    keywords: '亞立原,Arion,遊戲代理,遊戲研發,市場推廣,數位科技,創新服務,玩家體驗,遊戲產業,遊戲發行',
    canonical: siteUrl,
    schema
  });

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <ValuesSection />
      </main>
      <Footer />
    </div>
  );
}